<template>
  <section class="section">
    <div class="backBtn" v-on:click="$router.back()"
      v-if="$route.query.update === 'y'"></div>
    <h4 :class="{hasBack: $route.query.update === 'y'}">Pilih Karakter!</h4>
    <div class="charThumbCnt">
      <div class="charThumb nunu" :class="{inactive: selectedChar !== 'nunu'}"
        v-on:click="selectChar('nunu')">
        <div class="charImg"></div>
        Nunu
      </div>
      <div class="charThumb lili" :class="{inactive: selectedChar !== 'lili'}"
        v-on:click="selectChar('lili')">
        <div class="charImg"></div>
        Lili
      </div>
    </div>
    <div class="mainChar" v-if="selectedChar">
      <div class="theChar" :class="selectedChar"></div>
    </div>
    <div class="nameFormCnt">
      <form class="nameForm" v-on:submit.prevent="handleSubmit"
        v-if="selectedChar">
        <div :class="{fieldGroup: true, hasError: form.name.error}"
          v-if="!$route.query.update">
          <input type="text" class="field" placeholder="Masukan Nama"
            v-model="form.name.model" v-on:input="fieldChanged('name')">
          <div class="fieldError" v-if="form.name.error">{{form.name.error}}</div>
        </div>
        <button class="btn primary block"
          :class="{btnLoading: formLoading}">
          <span>Berikutnya</span></button>
      </form>
    </div>
  </section>
</template>

<script>

export default {
  name: 'home',
  components: {},
  data() {
    return {
      st: 1,
      form: {
        name: { model: '', error: null },
      },
      selectedChar: 'nunu',
      formLoading: false,
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    selectChar(char) {
      this.selectedChar = char;
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    doSave() {
      if (this.formLoading) return;
      this.formLoading = true;
      setTimeout(() => {
        this.formLoading = false;
        this.$router.push('/main');
      }, 1200);
    },
    handleSubmit() {
      if (this.formLoading) return;
      const formData = {
        character: this.selectedChar,
        name: this.form.name.model,
      };
      if (!formData.name || formData.name === '') {
        this.form.name.error = 'Mohon masukan nama untuk melanjutkan.';
        return;
      }
      this.formLoading = true;
      this.$http.post(this.$config.uri('user/set/name'), formData).then((r) => {
        this.formLoading = false;
        if (r.data.status !== 200) {
          this.form.name.error = 'Internal server error, please try again later.';
          return;
        }
        this.$session.set('bk6_name', formData.name);
        this.$session.set('bk6_character', formData.character);
        if (this.$route.query.update === 'y') {
          window.history.back();
          return;
        }
        // this.$router.push('/character/cosmetics');
        this.$router.push('/body-composition');
      });
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email') || this.$session.get('bk6_role') !== 'user') {
      this.$session.destroy();
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
    this.form.name.model = this.$session.get('bk6_name') || '';
    this.selectedChar = this.$session.get('bk6_character') || 'nunu';
  },
};
</script>

<style scoped lang="scss">
.section{
  padding: 30px 20px;
  min-height: 100vh;
  box-sizing: border-box;
  .backBtn{
    width: 46px; height: 46px;
    border-radius: 50%;
    background-color: #fff;
    background-image: url(../assets/arrow-back.png);
    background-size: 22px auto;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 20px; top: 16px;
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 24px;
    margin: 0 0 20px;
    &.hasBack{
      padding-left: 60px;
    }
  }
  .charThumbCnt{
    display: flex;
    margin: 0 0 20px;
    .charThumb{
      width: calc(50% - 10px);
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #006519;
      .charImg{
        height: 54px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
        margin-bottom: 4px;
        border: #78C90E 4px solid;
      }
      &.inactive{
        color: #999;
        .charImg{
          border-color: #ccc;
          filter: grayscale(1);
        }
      }
      &.nunu{
        margin-right: auto;
        .charImg{
          background-image: url(../assets/profile-nunu.png);
        }
      }
      &.lili{
        margin-left: auto;
        .charImg{
          background-image: url(../assets/profile-lili.png);
        }
      }
    }
  }
  .mainChar{
    // background-image: url(../assets/game-bg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 7px;
    position: absolute;
    top: 186px; bottom: 160px;
    left: 20px; right: 20px;
    .theChar{
      position: absolute;
      left: 0; right: 0; top: 24px; bottom: 30px;
      background-image: url(../assets/nunu-normal.png);
      background-position: bottom center;
      background-size: contain;
      background-repeat: no-repeat;
      &.lili{
        background-image: url(../assets/lili-normal.png);
      }
    }
  }
}

.charPreview{
  width: auto;
  height: 280px;
  background-image: url(../assets/nunu-iddle.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 20px auto 30px;
  position: relative;
  .head{
    background-color: red;
    height: 60px;
    position: absolute;
    top: 20px; left: 0; right: 0;
    opacity: .3;
  }
  .face{
    background-color: green;
    height: 60px; top: 80px;
    left: 0; right: 0;
    position: absolute;
    opacity: .3;
  }
  .body{
    background-color: brown;
    height: 60px; top: 180px;
    left: 0; right: 0;
    position: absolute;
    opacity: .3;
  }
}
.accCnt{
  margin: 0 0 26px;
  h5{
    margin: 0 7px 6px;
    text-align: left;
    font-size: 16px;
    color: #555;
  }
  .theAcc{
    display: flex;
    .accItem{
      width: 60px;
      height: 60px;
      background-color: #addc91;
      margin-right: 10px;
      border-radius: 12px;
      box-sizing: border-box;
      &.disabled{
        background-color: #ccc;
        color: #767676;
        font-size: 11px;
        padding-top: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
}

.nameFormCnt{
  position: fixed;
  left: 150px; right: 0; bottom: 0;
  @media (max-width: 768px) {
    left: 0;
  }
}
.nameForm{
  position: absolute;
  bottom: 40px; width: 420px;
  left: 50%; margin-left: -210px;
  @media (max-width: 500px) {
    left: 20px; right: 20px;
    width: auto; margin: 0;
  }
}
</style>
